"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _GhostIconButton = _interopRequireDefault(require("../Buttons/GhostIconButton"));
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Content = _styledComponents["default"].div.withConfig({
  displayName: "Drawer__Content",
  componentId: "sc-ueyuwr-0"
})(["background-color:", ";padding-top:", ";height:100%;overflow:auto;box-shadow:none;"], function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.theme.drawerHeaderHeight;
});

/**
 * Header can get props for color and background color as color names
 * or as hex values - by adding Hex at the end of the prop name. E.g:
 * <Header color="text">
 * <Header colorHex="#fff">
 * <Header backgroundColor="primary">
 * <Header backgroundColorHex="#ccc">
 */
var Header = _styledComponents["default"].div.withConfig({
  displayName: "Drawer__Header",
  componentId: "sc-ueyuwr-1"
})(["position:absolute;top:0;width:100%;height:", ";background:", ";color:", ";font-size:", ";font-weight:", ";display:flex;justify-content:center;align-items:center;z-index:", ";"], function (props) {
  return props.theme.drawerHeaderHeight;
}, function (props) {
  return (0, _helpers.getHexOrColor)(props, "backgroundColor", "primary");
}, function (props) {
  return (0, _helpers.getHexOrColor)(props, "color", "text");
}, function (props) {
  return props.theme.fontSizes.l;
}, function (props) {
  return props.theme.fontWeights.semibold;
}, function (props) {
  return props.theme.zIndex.above;
});
var HeaderButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Drawer__HeaderButtonWrapper",
  componentId: "sc-ueyuwr-2"
})(["position:absolute;right:0;top:50%;transform:translateY(-50%);opacity:0.8;&:hover{opacity:1;}"]);
var HeaderClose = function HeaderClose(props) {
  return /*#__PURE__*/_react["default"].createElement(HeaderButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_GhostIconButton["default"], _extends({
    name: "clearclose",
    color: "inherit",
    w: "fieldsHeight"
  }, props)));
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Drawer__Wrapper",
  componentId: "sc-ueyuwr-3"
})(["position:fixed;top:0;right:0;height:100%;z-index:", ";transform:translateX(101%);transition:all 0.2s linear;background-color:transparent;font-weight:semibold;width:400px;max-width:50vw;", ";", ""], function (props) {
  return props.theme.zIndex.drawer;
}, function (props) {
  return props.isOpen && (0, _styledComponents.css)(["transform:translateX(0);transition:all 0.2s linear;", "{box-shadow:", ";}"], Content, props.theme.boxShadow.drawer);
}, function (props) {
  return props.bottomFixed && (0, _styledComponents.css)(["height:", ";top:auto;bottom:0;"], props.hasScroll ? "100%" : "auto");
});

/** TODO: a possible improvement would be to create a component that handles its own "hasScroll" function, rather than expect it to be implemented in the component that uses the drawer. */

var Drawer = {
  Wrapper: Wrapper,
  Header: Header,
  HeaderClose: HeaderClose,
  Content: Content
};
var _default = Drawer;
exports["default"] = _default;